import { type FC, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LuArrowLeft } from 'react-icons/lu';
import { getUserPermissions, hasPermission } from '../config/permissions';
import { gruposConfigVisiveis, rotaCasaCom, ehSubmenu, type ItemConfig } from '../config/configuracoes';
import './ConfiguracoesRail.css';

interface Props {
    /**
     * Para onde o "voltar" leva: a última tela de operação em que o usuário
     * estava. Sem isso o único destino honesto seria um padrão fixo, e quem
     * entrou em Configurações a partir do Chat voltaria para o Painel.
     */
    voltarPara: string;
}

/**
 * O trilho da área de Configurações. Substitui a sidebar enquanto se está
 * numa rota de configuração — Direção A ("modo") da proposta de 2026-09-10.
 *
 * Grupo sem nenhum item permitido some inteiro, rótulo junto: um cabeçalho
 * "Sistema" sozinho só diz ao usuário que existe algo que ele não pode ver.
 */
const ConfiguracoesRail: FC<Props> = ({ voltarPara }) => {
    const location = useLocation();
    const permissoes = getUserPermissions();

    let empresa4Ou8 = false;
    try {
        const u = JSON.parse(localStorage.getItem('user') || '{}');
        empresa4Ou8 = u?.empresaId === 4 || u?.empresaId === 8;
    } catch { /* ignora */ }

    const grupos = useMemo(
        () => gruposConfigVisiveis(permissoes, empresa4Ou8, hasPermission),
        [permissoes, empresa4Ou8]);

    const item = (i: ItemConfig) => (
        <Link
            key={i.to}
            to={i.to}
            className={`cfg-item ${rotaCasaCom(location.pathname, i.to) ? 'is-active' : ''}`}
        >
            {i.rotulo}
        </Link>
    );

    return (
        <div className="cfg-slot">
            <aside className="cfg-rail" aria-label="Configurações">
                <Link to={voltarPara} className="cfg-voltar">
                    <LuArrowLeft size={15} />
                    <span>Configurações</span>
                </Link>

                <nav className="cfg-nav">
                    {grupos.map(g => (
                        <div className="cfg-grupo" key={g.titulo}>
                            <span className="cfg-grupo-tit">{g.titulo}</span>
                            {g.itens.map(e => ehSubmenu(e) ? (
                                /* Submenu (Sistema › Relatórios): rótulo sem tela,
                                   itens recuados com um fio à esquerda. */
                                <div className="cfg-submenu" key={e.rotulo}>
                                    <span className="cfg-submenu-tit">{e.rotulo}</span>
                                    <div className="cfg-submenu-itens">
                                        {e.itens.map(i => item(i))}
                                    </div>
                                </div>
                            ) : item(e))}
                        </div>
                    ))}
                </nav>
            </aside>
        </div>
    );
};

export default ConfiguracoesRail;
